import React, {
  useContext,
  createContext,
  useEffect,
  useState,
  useMemo,
  PropsWithChildren,
} from 'react';
import { CurrencyCode } from '../../../PaymentGateway/interfaces/currencies';
import axios from 'axios';
import { IP_DATA_URL } from '../../../../constants/ipData';

interface IPFetcherContent {
  country: string;
  currency: CurrencyCode;
  loading: boolean;
}

export const IPFetcherContext = createContext<IPFetcherContent | null>(null);

export interface IIPData {
  ip: string;
  country_code: string;
  currency: {
    code: CurrencyCode;
  };
}
//TODO: eliminate ip fetch from Frontend
export const getUserIP = async (): Promise<any> =>
  axios.get(`https://api.ipdata.co?api-key=${IP_DATA_URL}`, {
    transformRequest: (data, headers) => {
      delete headers.common['Authorization'];
      delete headers.common['X-Device-Platform'];
    },
  });

export const IPFetcherContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [country, setCountry] = useState<string>('US');
  const [currency, setCurrency] = useState<CurrencyCode>('USD');
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    getUserIP()
      .then((ip: IIPData) => {
        if (!ip.ip) {
          throw new Error('IP not found');
        }

        setCountry(ip.country_code);
        setCurrency(ip.currency.code);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const value = useMemo(
    () => ({
      country,
      currency,
      loading,
    }),
    [loading, country, currency],
  );

  return (
    <IPFetcherContext.Provider value={value}>
      {children}
    </IPFetcherContext.Provider>
  );
};

export const useIPFetcherProvider = () => useContext(IPFetcherContext);
